import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ScrollElements } from './scroll-ements';

@Directive({
  selector: '[appScrollToInvalidFieldOnFormSubmit]',
})
export class ScrollToInvalidFieldOnFormSubmitDirective implements OnInit {
  @Input()
  appScrollToInvalidFieldOnFormSubmit?: HTMLElement;

  @Input()
  scrollElement: ScrollElements = ScrollElements.SELF;

  scrollEl: any;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.detectScrollElement();
  }

  private detectScrollElement(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    switch (this.scrollElement) {
      case ScrollElements.SELF:
        this.scrollEl = this.appScrollToInvalidFieldOnFormSubmit;
        break;
      case ScrollElements.BODY:
        this.scrollEl = document.body;
        break;
      case ScrollElements.WINDOW:
        this.scrollEl = window;
        break;
    }
  }

  @HostListener('submit', ['$event'])
  onFormSubmit(event: Event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    setTimeout(() => {
      this.scrollToFirstInvalidControl();
    });
  }

  scrollToFirstInvalidControl() {
    const invalidControl: HTMLElement = this.el.nativeElement.querySelector(
      '.fields__item_error',
    );

    if (!invalidControl) {
      return;
    }

    this.scrollEl.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const offsetTop = 20;
    let scrollTop = 0;
    switch (this.scrollElement) {
      case ScrollElements.SELF:
        scrollTop = this.appScrollToInvalidFieldOnFormSubmit!.scrollTop;
        break;

      case ScrollElements.WINDOW:
        scrollTop = window.scrollY;
        break;

      case ScrollElements.BODY:
        scrollTop = document.body.scrollTop;
        break;
    }

    return controlEl.getBoundingClientRect().top + scrollTop - offsetTop;
  }
}
